import axios from "axios";
import { makeObservable, action } from "mobx";
import { getAPIBaseURL } from "../utils/EnvironmentUrls.mjs";
import ErrorUtil from "../utils/ErrorUtil.mjs";
import ApiError from "./ApiError.mjs";
class ApiService {
  static BAD_REQUEST = 400;
  static NOT_FOUND = 404;
  static SHORT_TIMEOUT = 3e4;
  apiBaseUrl = "/payment-frontend/api";
  environment;
  httpClient;
  constructor() {
    makeObservable(this, {
      setEnvironment: action,
      setHttpClient: action
    });
  }
  setEnvironment(environment, axiosInstance) {
    this.environment = environment;
    this.setHttpClient(axiosInstance);
  }
  setHttpClient(axiosInstance) {
    this.apiBaseUrl = getAPIBaseURL(this.environment);
    this.httpClient = axiosInstance || this.getAxiosInstance(ApiService.SHORT_TIMEOUT);
  }
  getBanklinks(includeV2) {
    return this.getRequest("/banklinks", { params: { includeV2 } });
  }
  getTranslations() {
    return this.getRequest("/translations");
  }
  getSettings() {
    return this.getRequest("/settings");
  }
  getBanklinkParameters(parameters) {
    return this.handleError(
      this.httpClient.post("/banklinks/parameters", parameters).then((response) => response.data)
    );
  }
  initiateV2Payment(parameters) {
    return this.handleError(
      this.httpClient.post("/v2/banklinks/initiate", parameters).then((response) => response.data)
    );
  }
  getBanklinkV2PaymentStatus(transactionReference) {
    return this.getRequest(`/v2/banklinks/payment-status/${transactionReference}`);
  }
  goToBank(path, params) {
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", path);
    form.setAttribute("target", "_parent");
    for (const key in params) {
      if (key == "BANK_URL") continue;
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
  startCardPayment(startPaymentRequest) {
    return this.handleError(
      this.httpClient.post("/card/start-payment", startPaymentRequest).then(
        (response) => response.data
      )
    );
  }
  getCardPaymentStatus(transactionReference) {
    return this.getRequest(`/card/payment-status/${transactionReference}`);
  }
  getAdyenPaymentMethodInputs(shopperReference, source) {
    return this.getRequest(`/card/adyen-payment-method-inputs`, {
      params: {
        shopperReference,
        source
      }
    });
  }
  deleteSavedCard(shopperReference, cardDetailsReference) {
    return this.getRequest(`/card/${shopperReference}/${cardDetailsReference}`);
  }
  static unwrapData(promise) {
    return promise.then((request) => request.data);
  }
  handleError(promise) {
    return promise.catch((error) => {
      if (error.response) {
        if (error.response.status === ApiService.BAD_REQUEST) {
          throw new ApiError(error, ApiService.BAD_REQUEST);
        }
        if (error.response.status === ApiService.NOT_FOUND) {
          throw new ApiError(error, ApiService.NOT_FOUND);
        }
      }
      ErrorUtil.registerError(error);
      throw new ApiError("Received error from backend " + error);
    });
  }
  getAxiosInstance(timeout) {
    const config = {
      baseURL: this.apiBaseUrl,
      timeout,
      headers: {
        Pragma: "no-cache"
      }
    };
    return axios.create(config);
  }
  getRequest(uri, config) {
    return this.handleError(ApiService.unwrapData(this.httpClient.get(uri, config)));
  }
}
export {
  ApiService as default
};
